import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { StyledNavigateSection } from './navigate-section';
import { StyledNavigateContent } from './navigate-content';

export function CreationHeader(props) {
  return (
    <div className="creation-header" style={{ ...props.style }}>
      <StyledNavigateSection content={<StyledNavigateContent crumbs={props.crumbs} />} ariaLabelText={_.first(props.crumbs)} {...props} />
    </div>
  );
}

CreationHeader.propTypes = {
  style: PropTypes.shape({}),
  crumbs: PropTypes.arrayOf(PropTypes.string),
};

CreationHeader.defaultProps = {
  style: {},
  crumbs: [],
};
